import { render, staticRenderFns } from "./MoveToNextStageMLBBTournament.vue?vue&type=template&id=1e23c1b6&scoped=true"
import script from "./MoveToNextStageMLBBTournament.vue?vue&type=script&lang=js"
export * from "./MoveToNextStageMLBBTournament.vue?vue&type=script&lang=js"
import style0 from "./MoveToNextStageMLBBTournament.vue?vue&type=style&index=0&id=1e23c1b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e23c1b6",
  null
  
)

export default component.exports